import { render, staticRenderFns } from "./whitePayPopup.vue?vue&type=template&id=764fdfca&scoped=true"
import script from "./whitePayPopup.vue?vue&type=script&lang=ts"
export * from "./whitePayPopup.vue?vue&type=script&lang=ts"
import style0 from "./whitePayPopup.vue?vue&type=style&index=0&id=764fdfca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764fdfca",
  null
  
)

export default component.exports